import { InjectionToken } from '@angular/core';
import { Environment } from '@viso/core/models';

export const ENVIRONMENT = new InjectionToken<Environment>(null);
